const interviewReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default interviewReducer;
